module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "btn-group pull-right",
    attrs: {
      "role": "group",
      "aria-label": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnNewEntryPoint
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" New")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Config " + _vm._s(_vm.app.name))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active show",
    attrs: {
      "id": "timeouts"
    }
  }, [(_vm.config) ? _c('div', [_c('modal', {
    attrs: {
      "title": "Create new entry point",
      "show": _vm.modalShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "width": "400"
    },
    on: {
      "update:show": function($event) {
        _vm.modalShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fas fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Set Entry point\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "selectType"
    }
  }, [_vm._v("Entry Point Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryPointType),
      expression: "entryPointType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.entryPointType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Helium View In WebApp")]), _vm._v(" "), _c('option', [_vm._v("Scheduled Function")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Entry Point Scope")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryPointScope),
      expression: "entryPointScope"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.entryPointScopeReadOnly,
      "placeholder": _vm.entryPointScopePlaceholder,
      "required": ""
    },
    domProps: {
      "value": (_vm.entryPointScope)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryPointScope = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Entry Point")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryPointName),
      expression: "entryPointName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.entryPointNamePlaceholder,
      "required": ""
    },
    domProps: {
      "value": (_vm.entryPointName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryPointName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Timeout Value (Minutes)")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryPointValue),
      expression: "entryPointValue"
    }],
    staticClass: "form-control",
    class: _vm.timeoutValueClass,
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.entryPointValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.timeoutValues), function(i) {
    return _c('option', [_vm._v("\n                    " + _vm._s(i) + "\n                    ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalCloseCallback
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalSaveCallback
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })]) : _c('div', [_c('form', [_c('fieldset', [(_vm.config) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabledApp),
      expression: "disabledApp"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disabledApp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Enable or disable this Helium app")]), _vm._v(" "), _c('option', [_vm._v("\n                      Enabled\n                    ")]), _vm._v(" "), _c('option', [_vm._v("\n                      Disabled\n                    ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnApplyEnabled
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  }), _vm._v(" Apply")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("A disabled App will not allow users to login and will not run any scheduled functions tasks to be processed")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lockedApp),
      expression: "lockedApp"
    }],
    staticClass: "custom-select form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lockedApp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Lock or unlock this Helium app")]), _vm._v(" "), _c('option', [_vm._v("\n                      Locked\n                    ")]), _vm._v(" "), _c('option', [_vm._v("\n                      Unlocked\n                    ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnApplyLocked
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  }), _vm._v(" Apply")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("A locked App will not allow users to login but background process will continue to run")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxDatabaseResults),
      expression: "maxDatabaseResults"
    }],
    staticClass: "form-control",
    class: _vm.maxDatabaseResultsValueClass,
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maxDatabaseResults = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.maxDatabaseResultsValues), function(i) {
    return _c('option', [_vm._v("\n                    " + _vm._s(i) + "\n                    ")])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.btnApplyMaxDatabaseResults
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  }), _vm._v(" Apply")])]), _vm._v(" "), _vm._m(7)]) : _vm._e()])]), _vm._v(" "), _c('app-config-entry-point', {
    attrs: {
      "config": _vm.config
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "schema-access"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('blockquote', {
    staticClass: "blockquote"
  }, [_c('form', [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("App")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.app.name),
      expression: "app.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.app.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.app, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Team")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teamUser),
      expression: "teamUser"
    }],
    staticClass: "custom-select form-control",
    attrs: {
      "id": "selectTeamName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.teamUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.teamNames), function(entry) {
    return _c('option', [_vm._v("\n                            " + _vm._s(entry) + "\n                        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-md",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip"
    },
    on: {
      "click": _vm.grantAccess
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                        Grant Access\n                      ")])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/apps"
    }
  }, [_vm._v("Apps")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Update timeout value")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-edit card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-inverse card-danger text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Remove timeout value")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-minus-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "href": "#timeouts"
    }
  }, [_vm._v("Timeouts")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#schema-access"
    }
  }, [_vm._v("Schema Access")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-6 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" App is currently:\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-6 col-form-label"
  }, [_c('i', {
    staticClass: "fas fa-lock-open",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" App is currently:\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-6 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-database",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Max Database Results\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Maximum number of results that can be returned by Helium's "), _c('code', [_vm._v("sql:query")]), _vm._v(" feature. See "), _c('a', {
    attrs: {
      "href": "https://wiki.mezzanineware.com/display/HTUT/Lesson+22%3A+Executing+SQL+Select+Queries+From+the+DSL"
    }
  }, [_vm._v("Lesson 22 (Executing SQL Select Queries From the DSL)")]), _vm._v(" for more information.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "timeouts-info",
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Schema Access")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("Alter DB obects (tables, views, functions, sequences) in the App Schema to owned by Helium and accessable by developers postgres accounts")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fc931d9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Config.vue
// module id = 582
// module chunks = 2